import React, { useState } from 'react';
import AppSettingsEditor from 'appToolbar/AppSettingsEditor';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';
import {
    CheckboxInput,
    NumericValueEditor,
} from '@instinet-analytics/semantic-ui-components';
import { useDispatchUpdateWidgetConfiguration } from 'widgets/store/configuration/hooks';
import { VenueAnalysisConfigurationState } from '../store/configuration/VenueAnalysisConfigurationState';
import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors';
import { useVenueAnalysisConfigSlice } from 'widgets/venueAnalysis/store/configuration/configSlice';
import './VenueAnalysisSettings.scss';

export default function VenueAnalysisSettings() {
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();
    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();

    const { config } = useVenueAnalysisConfigSlice();

    const dispatchUpdateWidgetConfig = useDispatchUpdateWidgetConfiguration();

    const { avgPriceDecimals, includePreviousDaysFills } = config;
    const [avgPriceDecimalsInputText, setAvgPriceDecimalsInputText] =
        useState(avgPriceDecimals);

    const onToggleIncludePreviousDaysFills = () => {
        const newValue = !includePreviousDaysFills;
        const configDelta: Partial<VenueAnalysisConfigurationState> = {
            includePreviousDaysFills: newValue,
        };
        dispatchUpdateWidgetConfig(configDelta);
    };

    const onAvgPriceDecimalsChanged = (nextValue: number) => {
        setAvgPriceDecimalsInputText(nextValue);
        const configDelta: Partial<VenueAnalysisConfigurationState> = {
            avgPriceDecimals: nextValue,
        };
        dispatchUpdateWidgetConfig(configDelta);
    };

    return (
        <div className="VenueAnalysisSettings">
            <div className="group">
                <div>
                    <CheckboxInput
                        label="Show portion of order filled in previous days' trading"
                        checked={!!includePreviousDaysFills}
                        onToggle={onToggleIncludePreviousDaysFills}
                    />
                </div>
            </div>
            <div className="decimals">
                <NumericValueEditor
                    className="decimals"
                    value={avgPriceDecimalsInputText}
                    label="Average Price decimal places"
                    max={4}
                    min={0}
                    onChange={onAvgPriceDecimalsChanged}
                />
            </div>
            {isAppModeNewportSingleWidget && (
                <AppSettingsEditor
                    appSettings={appSettings}
                    onAppSettingsChanged={dispatchUpdateAppSettings}
                    specifyVisibleControls={{
                        showChartHelp: true,
                        showTooltips: true,
                    }}
                />
            )}
        </div>
    );
}
